import Vue from 'vue';
import VueRouter from 'vue-router';
import { applyMiddleware } from './middleware'
// Career Shift
import CareerShiftRoot from '../components/CareerShift/Root';
import CareerShiftIndex from '../components/CareerShift/Index';
import CareerShiftResults from '../components/CareerShift/Results';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'jobscan-home',
        redirect: () => {
            window.location.href = '/';
            return;
        },
    },
    {
        path: '/career-change',
        component: CareerShiftRoot,
        children: [
            {
                path: '/',
                component: CareerShiftIndex,
            },
            {
                path: 'results',
                component: CareerShiftResults,
                name: 'CareerShiftResults',
            },
        ],
    },
    {
        path: '/career-change-remote-jobs',
        component: CareerShiftRoot,
        children: [
            {
                path: '/',
                component: CareerShiftIndex,
            },
            {
                path: 'results',
                component: CareerShiftResults,
                name: 'CareerShiftResultsRemote',
            },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

applyMiddleware(router)

export default router;
